import { ChangeDetectionStrategy, Component, EventEmitter, Input, model, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { Incident, ViewIncident } from 'src/app/api/incidents.service';

import { Columns, ColumnViews, Sizes, Styles } from './incident-table-types';

export interface IncidentAction {
  label: string;
  size: Sizes;
  style: Styles;
  validSteps?: number[];
  action: (incident: Incident) => void;
}

@Component({
    selector: 'app-incident-table2',
    templateUrl: './incident-table2.component.html',
    styleUrls: ['./incident-table2.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncidentTable2Component implements OnInit {


  private _incidents: ViewIncident[] = [];
  incidentMenus: Map<Incident, MenuItem[]> = new Map<Incident, MenuItem[]>()

  @Input() set incidents(value: ViewIncident[]) {
    this._incidents = value;
    this.createIncidentMenus()
  }

  get incidents(): ViewIncident[] {
    return this._incidents;
  }

  @Input()
  useTransitionButton: boolean = false;

  @Input()
  showSeverityImpact: boolean = false;

  private _actions: IncidentAction[] = [];

  @Input() set
    actions(value: IncidentAction[]) {
    this._actions = value
    this.createIncidentMenus()
  }

  get actions(): IncidentAction[] {
    return this._actions
  }

  @Input()
  view: ColumnViews = "incident"

  @Output()
  rowClick = new EventEmitter<Incident>();

  @Input()
  stateKey: string = "";

  @Input()
  loading: boolean = false;

  currentFilter = model("");

  constructor() { }


  ngOnInit(): void {
  }

  createIncidentMenus() {

    if (this._incidents.length > 0 && this.actions.length > 0) {
      this._incidents.forEach(incident => this.incidentMenus.set(incident, this.actions.filter(a => a.validSteps === undefined || a.validSteps.includes(incident.currentStepId)).map(action => { return { label: action.label, command: () => action.action(incident) } })))
    }
    else {
      this.incidentMenus = new Map<Incident, MenuItem[]>();
    }
  }

  onRowClick(incident: ViewIncident) {
    this.rowClick.emit(incident)
  }

  onIncidentUpdate(incident: ViewIncident) {

    const myIncidentIndex = this.incidents.findIndex(x => x.workItemId === incident.workItemId)

    if (myIncidentIndex > -1) {
      this.incidents[myIncidentIndex] = incident;
      this.incidents = [...this.incidents];  //trigger table refresh
    }


  }


  isColumnVisible(column: Columns) {

    //incident report
    if (this.view === "report") {
      return column !== "location" && column !== "priority" && column !== "assignee" && column !== "tags"
    }

    //incidents
    if (column === "submitted") {
      return false;
    }

    // Severity impact columns
    if (column === "personalInjury" || column === "financialImpact") {
      return this.showSeverityImpact;
    }

    return true;
  }

  clear(table: Table) {
    table.reset();
    table.clearState();
    this.currentFilter.set("");
  }

  tagChanged() {
    this.incidents = [...this.incidents];  //trigger table refresh
  }

  getMenuActions(incident: Incident) {
    return this.incidentMenus.get(incident) ?? []
  }

}